var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.$route.meta.bare)?_c('app-shell',[_c('transition',{attrs:{"name":"page","mode":"out-in"}},[_c('router-view',{key:_vm.$route.path})],1)],1):_c('router-view')
}
var staticRenderFns = []

export { render, staticRenderFns }